import React, { Component } from "react";
import _ from "lodash";
import cx from "classnames";
import {
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import PropTypes from "prop-types";
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import {
    withValidation,
    validationPropTypes,
} from '@xengage/gw-portals-validation-react';
import { CreditCardUtil } from '@xengage/gw-portals-util-js';
import { TranslatorContext } from "@jutro/locale";
import { AccountBillingDetailsService as BillingService } from "gw-capability-billing";
import { withRouter } from "react-router-dom";
import { Icon, ModalNextContext, withModalContext } from "@jutro/components";
import PaymentStyles from "./PEPaymentComponentExt.module.scss";
import metadata from "./PEPaymentComponentExt.metadata.json5";
import messages from "./PEPaymentComponentExt.messages";
import BluePay from "./BluePay";
import { LoaderExt } from 'gw-components-platform-react';


import { Link } from '@jutro/router';


class PEPaymentComponentExt extends Component {
  static contextType = TranslatorContext;

  static propTypes = {
      model: PropTypes.shape({
          paymentMethod: PropTypes.string,
          bankAccountData: PropTypes.shape({}),
          creditCardData: PropTypes.shape({}),
      }),
      viewModelService: PropTypes.shape({
          create: PropTypes.func,
      }).isRequired,
      onCallback: PropTypes.func.isRequired,
      xCenter: PropTypes.string.isRequired,
      title: PropTypes.shape({
          id: PropTypes.string.isRequired,
          defaultMessage: PropTypes.string.isRequired,
      }),
      history: PropTypes.shape({
          push: PropTypes.func,
      }).isRequired,
      hideTitle: PropTypes.bool,
      onCancel: PropTypes.func.isRequired,
      nextLabel: PropTypes.shape({
          id: PropTypes.string.isRequired,
          defaultMessage: PropTypes.string.isRequired,
      }),
      previousLabel: PropTypes.shape({
          id: PropTypes.string.isRequired,
          defaultMessage: PropTypes.string.isRequired,
      }),
      isSetupPayment: PropTypes.bool,
      isCustomFooter: PropTypes.bool,
      isDisabled: PropTypes.bool,
      isSelectedInvoiceAmount: PropTypes.bool,
      ...validationPropTypes,
  };

  static defaultProps = {
      model: undefined,
      title: undefined,
      hideTitle: false,
      nextLabel: undefined,
      previousLabel: undefined,
      isSetupPayment: false,
      isCustomFooter: false,
      isDisabled: false,
      isSelectedInvoiceAmount: false,
  };

  state = {
      paymentMethod: "",
      accountCreditCardVM: {},
      accountBankDetailVM: {},
      showValidationErrors: false,
      selectedradiobutton: "",
      abavalid: false,
      continuevalid: false,
      accountNumbervalid: false,
      checkboxEnabled: false,
      amountDue: 0,
      otherAmount: 0,
      setreadonly: false,
      setDropdown:'showdropdown',
      dropDownVisibility:' ',
      showmatchwarningMsg: false,
      isLoading: false,
      bluePayFlag:false,
  };

  componentDidMount = () => {
      let { accountCreditCardVM, accountBankDetailVM } = this.state;
      const { viewModelService, xCenter, model } = this.props;
      const initValue = {
          paymentMethod: "",
          bankAccountData: {},
          creditCardData: {},
      };

      const ModalNext = React.createContext(ModalNextContext);
      const mergedModel = Object.assign({}, initValue, model);
      const { creditCardData: cardDetailsModel } = mergedModel;
      const { bankAccountData: bankDetailsModel } = mergedModel;
      let { paymentMethod } = mergedModel;
      if (Object.keys(cardDetailsModel).length > 0) {
          paymentMethod = "creditcard";
      } else {
          paymentMethod = "wire";
      }

      accountCreditCardVM = viewModelService.create(
          cardDetailsModel,
          xCenter,
          "edge.capabilities.billing.dto.AccountCreditCardDTO"
      );
      accountBankDetailVM = viewModelService.create(
          bankDetailsModel,
          xCenter,
          "edge.capabilities.billing.dto.AccountBankDetailsDTO"
      );
      this.setState({
          paymentMethod,
          accountCreditCardVM,
          accountBankDetailVM,
      });
  };

  isModelValid = (viewModel) => {
      return viewModel.aspects
          ? viewModel.aspects.valid && viewModel.aspects.subtreeValid
          : false;
  };

  handlePaymentOptions = (data) => {
      this.setState({
          paymentMethod: data,
          showValidationErrors: false,
      });
  };

  writeValue = (value, path) => {
      const {
          paymentMethod,
          accountCreditCardVM,
          accountBankDetailVM,
      } = this.state;
      if (paymentMethod === "wire") {
          _.set(accountBankDetailVM, path, value);
          this.setState({ accountBankDetailVM });
      } else {
          _.set(accountCreditCardVM, path, value);
          this.setState({ accountCreditCardVM });
      }
  };

  payNowClicked = () => {
      const { onCallback } = this.props;
      const {
          paymentMethod,
          accountCreditCardVM,
          accountBankDetailVM,
      } = this.state;
      const paymentVM =
      paymentMethod === "wire" ? accountBankDetailVM : accountCreditCardVM;
      const isComponentValid = this.isModelValid(paymentVM);

      if (!isComponentValid) {
          this.setState({
              showValidationErrors: true,
          });
          return;
      }

      if (onCallback) {
          onCallback(paymentVM, paymentMethod);
      }
  };

  componentDidUpdate(previousprops) {
    const {checkboxEnabled,abavalid,accountNumbervalid,selectedradiobutton,amountDue,otherAmount,accountBankDetailVM}=this.state;
      if(this.props.selectedInvoiceStreamDropDownValue!==previousprops.selectedInvoiceStreamDropDownValue ){
        this.setState({selectedradiobutton:""});
        this.state.otherAmount= " ";
        this.state.checkboxEnabled='';
        this.state.paymentMethod='wire';
        
        if(!_.isEmpty(accountBankDetailVM.value.bankAccountNumber)){
            _.set(accountBankDetailVM.value,'bankAccountNumber',"\n");
        }
        if(!_.isEmpty(accountBankDetailVM.value.bankAccountNumberConfirmation)){
         _.set(accountBankDetailVM.value,'bankAccountNumberConfirmation',"\n");
        }
        if(!_.isEmpty(accountBankDetailVM.value.bankABANumber)){
        _.set(accountBankDetailVM.value,'bankABANumber',"\n");
        }
    }
      if (checkboxEnabled && abavalid && accountNumbervalid) {
          if (
              (selectedradiobutton === "amount Due" && amountDue > 0) ||
        (selectedradiobutton === "other" && otherAmount > 0)
          ) {
              if (this.state.continuevalid === false) {
                  // eslint-disable-next-line react/no-did-update-set-state
                  this.setState({ continuevalid: true });
              }
          } else if (this.state.continuevalid === true) {
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({ continuevalid: false });
          }
      } else if (this.state.continuevalid === true) {
      // eslint-disable-next-line react/no-did-update-set-state
          this.setState({ continuevalid: false });
      }
      if (selectedradiobutton === "") {
          if (this.state.amountDue > 0) {
              // eslint-disable-next-line react/no-did-update-set-state
              this.setState({
                  selectedradiobutton: "amount Due",
              });
          }
      // else{
      //     // eslint-disable-next-line react/no-did-update-set-state
      //     this.setState({
      //         selectedradiobutton:"other"
      //     })
      // }
      }
  }

  

  setAmount = (e) => {
       
      const amount=e.target.value;
      const validated = amount.match(/^(\d*\.{0,1}\d{0,2}$)/)
      if (validated) {
          this.setState({otherAmount:(e.target.value)})
      
      }
   
  };

getinputvalue=()=>{
    return <>$<input className={PaymentStyles.otheramountInput}
        type='number'
        name='name'
        disabled={this.state.selectedradiobutton==="amount Due"} 
        step={0.01}
        decimalPlaces={2}
        min={0} 
        value={this.state.otherAmount}
        //onChange={(e)=>{this.setState({otherAmount:(e.target.value)})}}/></>
        onChange={(e)=>{this.setAmount(e)}}/></>
}

  getAmounttoPayValues = () => {
      const values = [];
      if (this.props.dueAmount !== undefined) {
          const amountDue = Number(this.props.dueAmount.amount).toFixed(2);
          const value1 = {
              id: "amount Due",
              displayName: `$${amountDue}`,
          };
          values.push(value1);
          this.state.amountDue = this.props.dueAmount.amount;
      }
      return values;
  };

  getOthertoPayValues = () => {
      const values = [];
      const value1 = {
          id: "other",
          displayName: this.getinputvalue(),
      };
      values.push(value1);
      console.log(value1);
      return values;
  };

  handleradiobutton = (value) => {
      console.log(value);
      this.setState({ selectedradiobutton: value });
  };

  checkABA = (value) => {
      if (value) {
          let i;
          let n;
          let t;
          t = "";
          for (i = 0; i < value.length; i++) {
              const c = parseInt(value.charAt(i), 10);
              if (c >= 0 && c <= 9) t += c;
          }
          if (t.length !== 9) return false;
          n = 0;
          for (i = 0; i < t.length; i += 3) {
              n +=
          parseInt(t.charAt(i), 10) * 3 +
          parseInt(t.charAt(i + 1), 10) * 7 +
          parseInt(t.charAt(i + 2), 10);
          }
          if (n !== 0 && n % 10 === 0) {
              return true;
          }
          return false;
      }
      return false;
  };

  handleContinue = (e, paymentVM) => {
      e.preventDefault();
      if (!_.isEmpty(paymentVM)) {
          if (
              paymentVM.value.bankAccountNumber !==
        paymentVM.value.bankAccountNumberConfirmation
          ) {
              this.setState({ showmatchwarningMsg: true });
          } else {
              this.setState({ showmatchwarningMsg: false });
              this.setState({
                  setreadonly: true,
                  setDropdown:'hidedropdown'
              });
          }
      }

      const { history } = this.props;
      history.push({
        pathname: ``,
        state: {
            showData:true,
        //     accountNumber:history.location.state.accountNumber,
        //    accountName:history.location.state.accountname, 
        },
    });
  };

  handleValidation = (value, path) => {
      if (path === "bankABANumber") {
          const valid = this.checkABA(value);
          console.log(path, value);
          this.setState({
              abavalid: valid,
          });
      } else if (path === "bankAccountNumber") {
          if (value.length >= 4) {
              this.setState({
                  accountNumbervalid: true,
              });
          } else {
              this.setState({
                  accountNumbervalid: false,
              });
          }
      }
  };
  getEnrollmentText=()=>{
    return (
        <>
            <div className={PaymentStyles.enrollmentText}>
                {`You are about to make a payment for the account named below:`}
            </div>
            <div className={PaymentStyles.accountNumberAndName}> 
                <div>{this.props.accountName}</div>
                <div>{this.props.accountNumberVal}</div>
                <div>{this.props.multiStreamDropDownArray?.length > 1? this.props.selectedMultiInvoceStreamName:""}</div>
            </div>
            <br/>
        </>
    );    
}

  handlePayment = (e, paymentVM) => {
      e.preventDefault();
      this.setState({ isLoading: true });
      const { authHeader, history } = this.props;
      console.log(this.props);
      const payload = [];
      const details = {
          amountPaid: {
              currency: "usd",
              amount: 0,
          },
          paymentInstrument: {
              bankAccountData: {},
              paymentMethod: "webacheft",
          },
      };
      if (this.state.selectedradiobutton === "amount Due") {
          details.amountPaid.amount = this.state.amountDue;
      } else {
          details.amountPaid.amount = this.state.otherAmount;
      }
      details.paymentInstrument.bankAccountData = paymentVM.value;
      details.paymentInstrument.bankAccountData.bankName = "";
      details.invoiceStreamId =this.props.selectedInvoiceStreamDropDownValue;
      details.invoiceStreamName =this.props.selectedMultiInvoceStreamName;
      payload.push(details);
      payload.push(this.props.accountNumberVal);
      BillingService.makeAchPayment_Ext(payload, authHeader)
          .then((res) => {
            console.log(res);
           
              history.push({
                  pathname: `/accounts/${this.props.accountNumberVal}/billingAndPayment`,
                  state:{
                    res:res,
                    PaymentCanceled:"PaymentSuccess",
                    selectedMultiStreamDropdown:this.props.selectedInvoiceStreamDropDownValue
                }
              });
              
            //   objectData:[{
            //       accountNumber:this.props.accountNumberVal,
            //       invoiceStreamID:this.props.streamInternalID,
            //       invoiceStreamName:this.props.selectedMultiInvoceStreamName,
            //       multiStreamDropDownArray:this.props.multiStreamDropDownArray,
            //   }]
          })
          .finally(() => {
              this.setState({ isLoading: false }, () => {
                  console.log(this.state.isLoading);
              });
          });
  };

  onCanceledPayment = () => {
      const { history, accountNumber } = this.props;
      return history.push({
          pathname: `/accounts/${this.props.accountNumberVal}/billingAndPayment`,
          state: {
            PaymentCanceled:"PaymentCanceled",
            selectedMultiInvoceStreamName:this.props.selectedMultiInvoceStreamName
        },
      });
  };

  handleBack = () => {
      this.setState({
          setreadonly: false,
          setDropdown:'showdropdown',
      });
      const { history } = this.props;
      history.push({
        pathname: ``,
        state: {
            showData:false,
            accountNumber:this.props.accountNumberVal,
            selectedMultiStreamDropdown:this.props.selectedInvoiceStreamDropDownValue
        },
    });
  };

  getTermsandConditions = () => {
      return (
          <span>
              I have read and agree to the{" "}
              <Link
                  to="/"
                  style={{ "font-size": "1.1rem", color: "#26a9e0" }}
                  onClick={(e) => this.Popup(e)}
              >
                  Terms and Conditions
              </Link>
          </span>
      );
  };

  getTermsandConditionsMsg = () => {
      return (
          <div className={PaymentStyles.termsandconditions}>
              <span>
                  I authorize CopperPoint Insurance Company (“CopperPoint”) to debit the
                  bank account indicated in this web form for the noted amount on
                  today's date for payment of premium to CopperPoint on the account
                  referenced above. This authorization applies to payment of premium on
                  the account referenced above and to any credit entries to the account
                  to correct any erroneous deductions or to provide a refund of premium.
              </span>

              <span>
                  I understand that because this is an electronic transaction, these
                  funds may be withdrawn from my account as soon as the above noted
                  transaction date. In the case of an EFT/ACH Transaction being rejected
                  Non-Sufficient Funds (NSF), I understand that CopperPoint may, in its
                  discretion, attempt to process the charge again within 30 days. I
                  understand that an EFT/ACH Transaction rejected for Non-Sufficient
                  Funds (NSF) may result in cancellation or non-renewal of the policy on
                  the account referenced above.
              </span>

              <span>
                  I certify that I am an authorized user of this bank account, and that
                  I will not dispute the payment with my Bank so long as the transaction
                  corresponds to the terms indicated in this web form.
              </span>

              <span>
                  I authorize the financial institution identified by the routing number
                  above to accept and post entries to the account.
              </span>

              <span>
                  If I am engaging in a premium finance arrangement, I represent that it
                  is in accordance with applicable laws and that I have provided
                  CopperPoint with a copy of the premium finance agreement.
              </span>

              <span>
                  I have read and agree to all of the CopperPoint terms and conditions.
              </span>
          </div>
      );
  };

  Popup = (e) => {
      e.preventDefault();
      const { modalContext } = this.props;
      modalContext
          .showConfirm({
              title: messages.termandConditionsheader,
              message: this.getTermsandConditionsMsg(),
              confirmButtonText: "I Agree",
              cancelButtonText: "I Disagree",
          })
          .then((results) => {
              if (results === "confirm") {
                  return this.setState({ checkboxEnabled: true });
              }
              return this.setState({ checkboxEnabled: false });
          }, _.noop);
  };

  getpaymentOptions = () => {
      if ((this.state.amountDue<=10000) || (this.state.amountDue >10000  && this.props.grandfatherdAccount)) {
          return [
              {
                  code: "wire",
                  name: {
                      id: "quoteandbind.views.payment-details.Bank Account",
                      defaultMessage: "Bank Account",
                  },
              },
              {
                  code: "creditcard",
                  name: {
                      id: "quoteandbind.views.payment-details.Credit Card",
                      defaultMessage: "Credit Card",
                  },
              },
          ];
      }
      return [
          {
              code: "wire",
              name: {
                  id: "quoteandbind.views.payment-details.Bank Account",
                  defaultMessage: "Bank Account",
              },
          },
      ];
  };


  getCreditCardFlag=(value)=>{
   
    this.props.history.push({
        pathname: ``,
        state: {
            creditCardFlag: value,
            invoiceStreamId:this.props.selectedInvoiceStreamDropDownValue,
            invoiceStreamName:this.props.selectedMultiInvoceStreamName,
            accountNumberNew:this.props.accountNumberVal
        }
    });
    this.setState({bluePayFlag:value})
}

  render() {
      const translator = this.context;
      const {
          paymentMethod,
          accountCreditCardVM,
          accountBankDetailVM,
          showValidationErrors,
      } = this.state;
      const paymentVM =
      paymentMethod === "wire" ? accountBankDetailVM : accountCreditCardVM;
      const {
          title,
          nextLabel,
          previousLabel,
          onCancel,
          isCustomFooter,
          isDisabled,
          isSetupPayment,
          hideTitle,
          setComponentValidation,
          isSelectedInvoiceAmount,
      } = this.props;
      const isComponentValid = this.isModelValid(paymentVM);
      const creditCardIssuer = _.get(
          accountCreditCardVM.value,
          "creditCardIssuer",
          undefined
      );
      const overrides = {
          "@field": {
              phoneWide: {
                  labelPosition: "top",
              },
          },
          automaticPaymentMethod: {
              visible: isSetupPayment,
              value: translator(messages.bankAccountSource),
          },
          paymentOptions: {
              availableValues: this.getpaymentOptions(),
              value: paymentMethod,
              labelPosition: "left",
              //visible: !isSetupPayment && !this.state.setreadonly,
              visible: (this.state.setDropdown==='showdropdown')&&(this.state.dropDownVisibility!=='hideSourceDropdown')
          },
          bankAccountContainer: {
              visible: paymentMethod === "wire",
          },
          creditCardNumber: {
              mask: CreditCardUtil.getInputMaskForIssuerCode(creditCardIssuer),
          },

          payNow: {
              onClick: this.payNowClicked,
              content:
          translator(nextLabel) || translator(messages.paymentComponentBuyNow),
              disabled: isDisabled || isSelectedInvoiceAmount || !isComponentValid,
          },
          paymentOptionsTitle: {
              content: translator(title) || translator(messages.paymentMethod),
              visible: !hideTitle,
          },
          cancel: {
              visible: paymentMethod !== "creditcard",
              content: translator(previousLabel) || translator(messages.cancel),
          },
          nextbutton: {
              visible: paymentMethod !== "creditcard",
              disabled: !this.state.continuevalid,
              onClick: (e) => this.handleContinue(e, paymentVM),
          },
          buttonContainer: {
              className: cx(PaymentStyles.paymentButtonFooter, {
                  [PaymentStyles.paymentCustomFooter]: isCustomFooter,
              }),
              visible: !this.state.setreadonly,
          },
          cartbuttonContainer: {
              className: cx(PaymentStyles.paymentButtonFooter, {
                  [PaymentStyles.paymentCustomFooter]: isCustomFooter,
              }),
              visible: this.state.setreadonly,
          },
          amountPay: {
              visible: !this.state.setreadonly,
          },
          accountType: {
              visible: !this.state.setreadonly,
          },
          amountDue: {
              availableValues: this.getAmounttoPayValues(),
              onValueChange: this.handleradiobutton,
              value: this.state.selectedradiobutton,
              disabled: this.state.amountDue <= 0,
          },
          mismatchWarning: {
              visible: this.state.showmatchwarningMsg,
          },
          otherAmount: {
              availableValues: this.getOthertoPayValues(),
              onValueChange: this.handleradiobutton,
              value: this.state.selectedradiobutton,
          },
          accountNumber: {
              onValueChange: (value, path) => {
                  _.set(paymentVM, "bankAccountNumber", value);
                  this.handleValidation(value, path);
              },
              value: _.get(paymentVM, "bankAccountNumber.value"),
              visible: !this.state.setreadonly,
          },
          confirmAccountNumber: {
              visible: !this.state.setreadonly,
          },
          abaNumber: {
              onValueChange: (value, path) => {
                  _.set(paymentVM, "bankABANumber", value);
                  this.handleValidation(value, path);
              },
              value: _.get(paymentVM, "bankABANumber.value"),
              visible: !this.state.setreadonly,
          },
          checkboxACH: {
              onValueChange: (value) => {
                  this.setState({ checkboxEnabled: value });
              },
              value: this.state.checkboxEnabled,
              visible: !this.state.setreadonly && paymentMethod === "wire",
              label: this.getTermsandConditions(),
          },
          cartAmount: {
              visible: this.state.setreadonly,
              value:
          this.state.selectedradiobutton === "amount Due"
              ? `$${this.state.amountDue}`
              : `$${this.state.otherAmount}`,
          },
          cartaccountType: {
              visible: this.state.setreadonly,
              value: _.capitalize(_.get(paymentVM.value, "bankAccountType")),
          },
          cartaccountNumber: {
              visible: this.state.setreadonly,
          },
          cartabaNumber: {
              visible: this.state.setreadonly,
          },
          paybutton: {
              onClick: (e) => this.handlePayment(e, paymentVM),
          },
          creditlimitwarning: {
              visible: this.state.amountDue >= 0 && !this.state.setreadonly,
          },
          enrollmentMessageText:{
            content:this.getEnrollmentText()
        }
      };

      const resolvers = {
          resolveClassNameMap: PaymentStyles,
          resolveCallbackMap: {
              handlePaymentOptions: this.handlePaymentOptions,
              getAmounttoPayValues: this.getAmounttoPayValues,
              onCancel: this.onCanceledPayment,
              onBack: this.handleBack,
          },
      };

      const readValue = (id, path) => {
          return readViewModelValue(
              metadata.componentContent,
              paymentVM,
              id,
              path,
              overrides
          );
      };

      const { isLoading } = this.state;
      if (isLoading) {
          return (
              <div>
                  <LoaderExt loaded={!isLoading} />
                  <div className={PaymentStyles.flexdiv}>
                      <div className={PaymentStyles.maincontent}>
                          <Icon icon="mi-warning" className={PaymentStyles.msgicon} />
                          <h4>
                              Your payment is processing.Please do not press the back button
                              or close your browser
                          </h4>
                      </div>
                  </div>
              </div>
          );
      }

      if (paymentMethod === "creditcard") {
          return (
              <>
                  <ViewModelForm
                      uiProps={metadata.componentContent}
                      model={paymentVM}
                      showErrors={showValidationErrors}
                      overrideProps={overrides}
                      resolveValue={readValue}
                      onValidationChange={setComponentValidation}
                      onValueChange={this.writeValue}
                      classNameMap={resolvers.resolveClassNameMap}
                      callbackMap={resolvers.resolveCallbackMap}
                  />

                  <BluePay
                      userInfo={this.props.userInfo}
                      accountNumber={this.props.accountNumberVal}
                      amountDue={this.props.dueAmount}
                      setCallback={(value)=>{
                        
                          this.setState({
                            
                              dropDownVisibility:value
                          });
                       
                        
                    
                      }}
                      creditCard={(value) => this.getCreditCardFlag(value)}
                  />
                  {this.state.bluePayFlag ? (
                        <div>
                            <div className={PaymentStyles.enrollmentText}>
                                {`You are about to make a payment for the account named below:`}
                            </div>
                            <div className={PaymentStyles.accountNumberAndName}>
                                <div>{this.props.accountName}</div>
                                <div>{this.props.accountNumberVal}</div>
                                <div>{this.props.selectedMultiInvoceStreamName}</div>
                            </div>
                        </div>
                    ) : ('')
                    }
              </>
          );
      }
      return (
          <ViewModelForm
              uiProps={metadata.componentContent}
              model={paymentVM}
              showErrors={showValidationErrors}
              overrideProps={overrides}
              resolveValue={readValue}
              onValidationChange={setComponentValidation}
              onValueChange={this.writeValue}
              classNameMap={resolvers.resolveClassNameMap}
              callbackMap={resolvers.resolveCallbackMap}
          />
      );
  }
}

export default withRouter(
    withValidation(
        withModalContext(
            withViewModelService(withAuthenticationContext(PEPaymentComponentExt))
        )
    )
);
